/**
 * KM Predictive Search v5.11 (01/11/2026) — T1 fautes/séparateurs, T2 ordre des pages d'index, T3 langue (/en). Base v5.10 (lien vert « Aucun produit »). v5.9 (28/10/2026) — suggestions sans attendre le réseau, remplissage rapide à froid, mise à jour légère, bon classement
 * - v5 : (a) 1re visite : index lu dans l'ordre des ventes, 750 produits en ~1 s (page 1, puis pages 2 et 3 en parallèle), le reste après le chargement ; (b) revalidation toutes les 10 min par 5 mini-requêtes de somme de contrôle (/collections/all?view=km-ver) : l'index n'est retéléchargé que si le catalogue a changé (ou après 60 min) ; (c) classement : produits DISPONIBLES d'abord (tous les mots, puis modèles proches), ruptures en dernier ; mot exact avant préfixe ; rien n'est retiré.
 * - Structure API : data.resources.results.products
 */
(function () {
  'use strict';

  /* Eviter double initialisation si le script est chargé plusieurs fois */
  if (window.__kmSearchInit) return;
  window.__kmSearchInit = true;

  /* v5.11 (T3) : racine de la langue courante ("/" ou "/en/") fournie par Shopify ; les requêtes et les liens y restent. Clé de stockage propre à chaque langue (titres traduits). */
  var ROOT = (window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string') ? window.Shopify.routes.root : '/';
  if (ROOT.charAt(0) !== '/') ROOT = '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';
  var LS_KEY = 'kmsp5' + (ROOT === '/' ? '' : ROOT.replace(/[^a-z]/gi, '')), FRESH = 10 * 60 * 1000, PRICE_OK = 30 * 60 * 1000, MAXAGE = 24 * 3600 * 1000, MAX = 10;
  var pool = Object.create(null);   /* url -> produit compact (tous les produits déjà vus) */
  var cacheQ = Object.create(null); /* requête normalisée -> liste de produits (réponse réseau) */
  var poolTs = 0, fullTs = 0, saveT = null, checking = false;
  var FULLMAX = 60 * 60 * 1000, BS = ROOT + 'collections/all?view=km-index&sort_by=best-selling&page=', VER_URL = ROOT + 'collections/all?view=km-ver&page=';

  function fmt(x) {
    return String(Math.round(Number(x))).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' FCFA';
  }

  /* Échappe le HTML : titres produits et saisie du client sont insérés via innerHTML */
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Surligne CHAQUE mot saisi (début de mot, sans accents ni casse), où qu'il soit dans le titre, comme Glotelho ; un synonyme (glace, coque…) surligne le mot du catalogue (Glass, Pochette).
     On découpe le texte brut, puis on échappe chaque morceau. */
  function hl(text, q) {
    text = String(text == null ? '' : text);
    var toks = canon(q).split(' ').filter(Boolean), low = '', mark = [], i, k, c, p, tok, out = '', open = false;
    if (!toks.length) return esc(text);
    for (i = 0; i < text.length; i++) { c = norm(text.charAt(i)); low += c.length === 1 ? c : (c.charAt(0) || ' '); mark.push(false); }
    for (k = 0; k < toks.length; k++) {
      tok = toks[k]; p = low.indexOf(tok);
      while (p > -1) {
        if (p === 0 || !/[a-z0-9]/.test(low.charAt(p - 1))) for (i = p; i < p + tok.length; i++) mark[i] = true;
        p = low.indexOf(tok, p + 1);
      }
    }
    for (i = 0; i < text.length; i++) {
      if (mark[i] && !open) { out += '<em>'; open = true; }
      if (!mark[i] && open) { out += '</em>'; open = false; }
      out += esc(text.charAt(i));
    }
    return out + (open ? '</em>' : '');
  }

  function norm(s) {
    s = String(s || '').toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return s.replace(/\s+/g, ' ').trim();
  }

  /* Synonymes d'usage (saisie -> mot du catalogue) : coque/étui/housse = pochette ; verre/glace/vitre = glass. Source : synonymes Shopify Search & Discovery / Algolia (synonyms). */
  var SYN = { coque: 'pochette', coques: 'pochette', etui: 'pochette', etuis: 'pochette', housse: 'pochette', housses: 'pochette', 'case': 'pochette', verre: 'glass', verres: 'glass', glace: 'glass', glaces: 'glass', vitre: 'glass', vitres: 'glass' };
  function canon(q) { return norm(q).replace(/\bi phone\b/g, 'iphone').split(' ').map(function (t) { return SYN[t] || t; }).join(' '); }

  function sugUrl(q) {
    q = canon(q);
    return ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10' +
      '&resources[options][unavailable_products]=last';
  }

  /* Index catalogue (templates/collection.km-index.liquid) : tableau JSON compact, 250 produits par page */
  function fromIndex(r, s) {
    return {
      t: r.t, u: r.u, p: r.p || '', c: (r.c && r.c > r.p) ? r.c : '', i: r.i || '', a: !!r.a,
      h: ' ' + norm(r.t + ' ' + (r.v || '') + ' ' + (r.y || '')), y: norm(r.y || ''), s: s
    };
  }

  /* Liste produits depuis la réponse API (structure correcte + fallback) */
  function extract(resources) {
    var products = [];
    if (resources && resources.results) {
      products = Array.isArray(resources.results.products) ? resources.results.products : [];
    }
    if (!products.length && resources && resources.products && Array.isArray(resources.products.results)) {
      products = resources.products.results;
    }
    return products;
  }

  /* Produit réduit aux champs utiles (h = texte de recherche normalisé, précédé d'un espace) */
  function compact(p) {
    var priceVal = (p.price != null && p.price !== '') ? p.price : p.price_min;
    return {
      t: p.title || '',
      u: p.url,
      p: priceVal || '',
      c: (p.compare_at_price_min && Number(p.compare_at_price_min) > Number(priceVal)) ? p.compare_at_price_min : '',
      i: p.featured_image ? p.featured_image.url : '',
      a: p.available !== false,
      h: ' ' + norm((p.title || '') + ' ' + (p.vendor || '') + ' ' + (p.type || '')), y: norm(p.type || '')
    };
  }

  /* Un produit n'entre dans le pool que s'il est complet (protège contre un stockage corrompu ou d'une ancienne version) */
  /* Clé du pool = adresse sans paramètres (?_pos=…) : le même produit venu de l'index et du réseau n'apparaît qu'une fois */
  function ukey(u) { return String(u).split('?')[0]; }

  function valid(it) {
    return !!it && typeof it === 'object' && typeof it.u === 'string' && typeof it.t === 'string' && typeof it.h === 'string';
  }

  /* Type de produit (champ "Type" Shopify) : Smartphone / Tablette / Téléphone à touches = appareils ; tout le reste (Pochette, Glass de protection, Powerbank…) = accessoires.
     Les mots des types d'accessoires servent à reconnaître l'intention de la saisie ("glass", "pochette"…) : source = Algolia Query Categorization / Amazon (type de produit visé par la requête). */
  var DEV = { 'smartphone': 1, 'tablette': 1, 'telephone a touches': 1 }, accW = Object.create(null);
  function isAcc(it) { return !!it.y && !DEV[it.y]; }
  function noteType(it) { if (isAcc(it)) it.y.split(' ').forEach(function (w) { if (w.length > 2) accW[w] = 1; }); }
  /* v5.9 : un mot tapé désigne un type d'accessoire s'il est ENTIER ("glass", "pochette") ou, à partir de 4 lettres, un début de ce mot ("poche…") ;
     sauf les noms de modèles ("pro", "pop", "plus"…) qui ne comptent que s'ils sont entiers : "pro" ne doit plus déclencher "protection" (cause du 29/10 : « xiaomi 17 pro max » montrait des glass en premier) */
  var MODEL_W = { pro: 1, pop: 1, max: 1, plus: 1, mini: 1, lite: 1, ultra: 1, note: 1, play: 1, neo: 1, star: 1, spark: 1, hot: 1, smart: 1, camon: 1, power: 1, prime: 1, fold: 1, flip: 1, edge: 1, pova: 1, phantom: 1, redmi: 1, poco: 1 };
  function isTypeTok(t) {
    if (t.length < 3) return false;
    for (var w in accW) { if (w === t) return true; if (t.length >= 4 && !MODEL_W[t] && w.indexOf(t) === 0) return true; }
    return false;
  }
  function accIntent(toks) { return toks.some(isTypeTok); }

  /* s = rang de ventes (position dans l'index "meilleures ventes") : départage les égalités, toujours dans le même ordre (affichage local ou réponse Shopify) */
  function putItem(it) {
    var k = ukey(it.u), old = pool[k];
    if (it.s == null && old && old.s != null) it.s = old.s;
    pool[k] = it; noteType(it);
  }
  function addToPool(list) {
    list.forEach(function (it) { if (valid(it)) { putItem(it); } });
    clearTimeout(saveT);
    saveT = setTimeout(function () {
      try {
        var arr = [], k;
        for (k in pool) arr.push(pool[k]);
        localStorage.setItem(LS_KEY, JSON.stringify({ t: poolTs, f: fullTs, items: arr.slice(0, 2500) }));
      } catch (e) {}
    }, 1500);
  }

  (function loadPool() {
    try {
      var d = JSON.parse(localStorage.getItem(LS_KEY) || 'null');
      if (d && Array.isArray(d.items) && Date.now() - d.t < MAXAGE) {
        poolTs = d.t; fullTs = ('f' in d) ? Number(d.f) || 0 : d.t; /* copie v4.6 sans 'f' = complète ; f=0 = partielle (250 produits) */
        if (Array.isArray(d.items)) d.items.forEach(function (it) { if (valid(it)) { putItem(it); } });
      }
    } catch (e) {}
  })();

  /* Chaque mot de la saisie = début d'un mot du titre/marque/type */
  /* v5.11 (T1) : "LD-63" se trouve aussi par "ld 63" et "ld63". Deux formes calculées une fois par produit (propriété non énumérable : jamais écrite dans le stockage) :
     a = tirets remplacés par des espaces ("ld 63"), b = tirets retirés entre deux caractères ("ld63"). Seuls les titres contenant un tiret en ont. */
  function altOf(it) {
    var g = it._g;
    if (g === undefined) {
      g = it.h.indexOf('-') > -1 ? { a: it.h.replace(/-/g, ' '), b: it.h.replace(/([a-z0-9])-(?=[a-z0-9])/g, '$1') } : null;
      try { Object.defineProperty(it, '_g', { value: g, writable: true }); } catch (e) {}
    }
    return g;
  }
  function hasWord(it, w) {
    if (it.h.indexOf(w) > -1) return true;
    var g = altOf(it);
    return !!g && (g.a.indexOf(w) > -1 || g.b.indexOf(w) > -1);
  }
  function matchAll(it, toks) {
    for (var j = 0; j < toks.length; j++) if (!hasWord(it, ' ' + toks[j])) return false;
    return true;
  }
  /* Nombre de mots saisis qui correspondent à un mot ENTIER (critère "exactness" d'Algolia : mot exact avant préfixe) */
  function exact(it, toks) {
    var n = 0, j, t;
    for (j = 0; j < toks.length; j++) {
      t = ' ' + toks[j];
      if (it.h.indexOf(t + ' ') > -1 || it.h.slice(-t.length) === t) n++;
    }
    return n;
  }
  /* Ordre (règle Stefan 28/10 ; sources : Shopify "ruptures en dernier" ; Algolia : mots tous présents, mot exact avant préfixe, popularité en cas d'égalité ; Algolia/Amazon : type de produit visé par la saisie) :
     1) DISPONIBLES qui contiennent TOUS les mots tapés · 2) DISPONIBLES approchants (modèles proches) · 3) RUPTURES qui contiennent tous les mots · 4) RUPTURES approchantes.
     Dans chaque groupe : appareils d'abord (téléphones, tablettes) puis accessoires, SAUF si la saisie nomme un type d'accessoire ("glass", "pochette"…) : accessoires d'abord ;
     puis mots exacts ; puis ordre d'origine (= meilleures ventes, tri stable). */
  function cmp(toks) {
    var wantAcc = accIntent(toks), phr = ' ' + toks.join(' ');
    return function (a, b) {
      if (a.a !== b.a) return a.a ? -1 : 1;
      var d = (matchAll(a, toks) ? 0 : 1) - (matchAll(b, toks) ? 0 : 1);
      if (d) return d;
      /* proximité (Algolia) : la saisie telle quelle, mots dans l'ordre et collés ("hot 7" dans "Infinix Hot 70") avant des mots dispersés ("Hotwav … 7.2") */
      d = (hasWord(a, phr) ? 0 : 1) - (hasWord(b, phr) ? 0 : 1); if (d) return d;
      d = (isAcc(a) ? 1 : 0) - (isAcc(b) ? 1 : 0);
      if (d) return wantAcc ? -d : d;
      d = exact(b, toks) - exact(a, toks);
      if (d) return d;
      return (a.s == null ? 1e9 : a.s) - (b.s == null ? 1e9 : b.s);
    };
  }
  /* ORDRE FINAL (règle Stefan 28/10, = Shopify "ruptures en dernier") : produits DISPONIBLES d'abord, ruptures à la fin ; rien n'est retiré, sauf au-delà de MAX
     (le lien "Voir tous les résultats" donne le reste). */
  function rank(list, q) {
    var toks = canon(q).split(' ').filter(Boolean);
    if (!toks.length) return list.slice(0, MAX);
    return list.slice().sort(cmp(toks)).slice(0, MAX);
  }

  /* Produits du pool : tous les mots d'abord ; si peu de produits disponibles, on retire les derniers mots (comme "removeWordsIfNoResults" d'Algolia)
     pour proposer des modèles proches disponibles (ex. Hot 40i en rupture => Hot 60i, Hot 70 disponibles). */
  /* Nombre de produits EN RUPTURE qui contiennent tous les mots saisis (annoncé en bas du menu : rien n'est caché sans le dire) */
  function outCount(q) {
    var toks = canon(q).split(' ').filter(Boolean), n = 0, key;
    if (!toks.length) return 0;
    for (key in pool) if (!pool[key].a && matchAll(pool[key], toks)) n++;
    return n;
  }
  function poolCount() { var n = 0, k; for (k in pool) { n++; if (n > 500) break; } return n; }
  /* a et b ne diffèrent que d'une lettre (ajout, retrait ou changement) */
  function oneOff(a, b) {
    var i = 0, j = 0, e = 0, m;
    if (Math.abs(a.length - b.length) > 1) return false;
    /* v5.11 (T1) : deux lettres voisines inversées ("xiaoim" pour "xiaomi") = une seule faute */
    if (a.length === b.length) {
      while (m === undefined && i < a.length) { if (a.charAt(i) !== b.charAt(i)) m = i; else i++; }
      if (m !== undefined && m + 1 < a.length && a.charAt(m) === b.charAt(m + 1) && a.charAt(m + 1) === b.charAt(m) && a.slice(m + 2) === b.slice(m + 2)) return true;
      i = 0;
    }
    while (i < a.length && j < b.length) {
      if (a.charAt(i) === b.charAt(j)) { i++; j++; continue; }
      if (++e > 1) return false;
      if (a.length > b.length) i++; else if (a.length < b.length) j++; else { i++; j++; }
    }
    return e + (a.length - i) + (b.length - j) <= 1;
  }
  function relevant(it, q) {
    var toks = canon(q).split(' ').filter(Boolean), words, ok = matchAll(it, toks);
    if (ok) return true;
    words = it.h.split(' ');
    return toks.every(function (t) {
      return words.some(function (w) { return w.indexOf(t) === 0 || (t.length >= 5 && w.length >= 4 && (oneOff(t, w.slice(0, t.length)) || oneOff(t, w.slice(0, t.length - 1)) || oneOff(t, w.slice(0, t.length + 1)))); });
    });
  }
  function localMatch(q) {
    var toks = canon(q).split(' ').filter(Boolean), out = [], seen = Object.create(null), key, i, avail = 0, extra, sets = [], sub, typeT, other;
    if (!toks.length) return out;
    for (key in pool) if (matchAll(pool[key], toks)) { out.push(pool[key]); seen[key] = 1; if (pool[key].a) avail++; }
    /* relâchement : on retire les derniers mots du MODÈLE, jamais le mot de type (glass, pochette…) ; sans mot de type : derniers mots */
    typeT = toks.filter(isTypeTok); other = toks.filter(function (t) { return !isTypeTok(t); });
    if (typeT.length) { for (i = other.length - 1; i >= 1; i--) sets.push(other.slice(0, i).concat(typeT)); }
    else { for (i = toks.length - 1; i >= 1; i--) sets.push(toks.slice(0, i)); }
    for (i = 0; i < sets.length && avail < 5 && out.length < MAX * 4; i++) {
      sub = sets[i]; extra = [];
      for (key in pool) if (!seen[key] && matchAll(pool[key], sub)) { extra.push(pool[key]); seen[key] = 1; }
      extra.sort(cmp(sub));
      extra.forEach(function (it) { out.push(it); if (it.a) avail++; });
    }
    return rank(out, q);
  }

  /* Index catalogue : pages lues UNE PAR UNE (300 ms d'écart) jusqu'à une page incomplète. */
  function wait(ms) { return new Promise(function (ok) { setTimeout(ok, ms); }); }
  function getJson(url, opt) {
    return fetch(url, opt).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  function readPages(n, rows) {
    return getJson(ROOT + 'collections/all?view=km-index&page=' + n, { cache: 'no-cache' }).then(function (p) {
      rows = rows.concat(p);
      if (p.length < 250 || n >= 12) return rows;
      return wait(300).then(function () { return readPages(n + 1, rows); });
    });
  }
  /* Sommes de contrôle du catalogue (prix, promo, stock, titre, image) : quelques octets par page de 250 produits */
  function getVers(n, out) {
    out = out || [];
    return getJson(VER_URL + n, { cache: 'no-store' }).then(function (v) {
      out.push({ n: v.n, k: v.k });
      if (v.n < 250 || n >= 12) return out;
      return wait(300).then(function () { return getVers(n + 1, out); });
    });
  }
  function sameVers(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) if (a[i].n !== b[i].n || a[i].k !== b[i].k) return false;
    return true;
  }
  function getMeta() { try { return JSON.parse(localStorage.getItem(LS_KEY + 'v') || 'null'); } catch (e) { return null; } }
  function setMeta(m) { try { if (m) localStorage.setItem(LS_KEY + 'v', JSON.stringify(m)); else localStorage.removeItem(LS_KEY + 'v'); } catch (e) {} }
  function conn() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
  }
  function backoff() { try { return Date.now() < Number(localStorage.getItem(LS_KEY + 'b') || 0); } catch (e) { return false; } }
  function setBackoff() { try { localStorage.setItem(LS_KEY + 'b', String(Date.now() + 5 * 60 * 1000)); } catch (e) {} }
  function poolEmpty() { for (var k in pool) return false; return true; }

  /* ÉTAPE 1 — lecture de l'index dans l'ordre des ventes : page 1 (250 produits les plus vendus), puis pages 2 et 3 EN PARALLÈLE (2 requêtes en même temps au maximum :
     Shopify répond 429 à partir de 4 en rafale), soit 750 produits en ~1 s ; les pages suivantes attendent la fin du chargement de la page puis partent une par une (300 ms d'écart).
     Chaque page entre dans le pool dès son arrivée : les recherches populaires sont locales tout de suite, même à la 1re visite. */
  var loadedP = null;
  function afterLoad() {
    if (!loadedP) loadedP = new Promise(function (ok) {
      function go() { setTimeout(ok, 1000); }
      if (document.readyState === 'complete') go();
      else { window.addEventListener('load', go); setTimeout(ok, 7000); }
    });
    return loadedP;
  }
  function stream(started) {
    var rows = [], pages = [];
    function pg(n) {
      return getJson(BS + n, { cache: 'no-cache' }).then(function (p) {
        /* v5.11 (T2) : pages 2 et 3 partent ensemble et peuvent arriver dans le désordre ; les rangs de vente viennent de la POSITION dans rows : on range par numéro de page */
        pages[n] = p;
        rows = [].concat.apply([], pages.filter(Boolean));
        if (poolEmpty()) poolTs = started;
        addToPool(p.map(function (r, i) { return fromIndex(r, (n - 1) * 250 + i); }));
        return p;
      });
    }
    function seq(n) {
      return wait(300).then(function () { return pg(n); }).then(function (p) { return (p.length < 250 || n >= 12) ? rows : seq(n + 1); });
    }
    return pg(1).then(function (p) {
      if (p.length < 250) return rows;
      return Promise.all([pg(2), pg(3)]).then(function (r) {
        if (r[0].length < 250 || r[1].length < 250) return rows;
        return afterLoad().then(function () { return seq(4); });
      });
    });
  }

  /* Revalide l'index si nécessaire. Le pool existant reste utilisé pendant ce temps. En cas d'échec (ex. 429) : on garde l'ancien pool, pause de 5 min.
     ÉTAPE 2 — si les sommes de contrôle n'ont pas changé (et moins de 60 min depuis le dernier téléchargement complet) : pas de retéléchargement. */
  function refreshIndex() {
    if (checking) return;
    if (fullTs && Date.now() - fullTs < FRESH) return;
    if (conn() || backoff()) return;
    checking = true;
    var started = Date.now(), meta = getMeta();
    /* Téléchargement complet. v = sommes de contrôle déjà lues AVANT (cas normal) ; sinon lues juste APRÈS (1er passage) : au pire une mise à jour
       survenue pendant ces ~3 s est rattrapée par le téléchargement complet forcé toutes les 60 min. */
    function commit(rows, v) {
      if (!rows.length) return;
      /* index complet : on remplace le pool (produits retirés du catalogue disparaissent) */
      pool = Object.create(null);
      poolTs = fullTs = started;
      addToPool(rows.map(function (r, i) { return fromIndex(r, i); }));
      setMeta(v ? { v: v, dl: started } : null);
    }
    function full(v) {
      return stream(started).then(function (rows) {
        if (!rows.length) return;
        return (v ? Promise.resolve(v) : getVers(1).catch(function () { return null; })).then(function (v2) {
          var uniq = Object.create(null), n = 0, total;
          rows.forEach(function (r) { if (!uniq[r.u]) { uniq[r.u] = 1; n++; } });
          total = v2 ? v2.reduce(function (t, x) { return t + x.n; }, 0) : n;
          /* le classement par ventes a bougé pendant la lecture (doublon ou produit manquant) : on relit dans l'ordre stable du catalogue */
          if (n !== rows.length || n !== total) return readPages(1, []).then(function (rows2) { commit(rows2, v2); });
          commit(rows, v2);
        });
      });
    }
    var job;
    if (meta && meta.v && started - meta.dl < FULLMAX && !poolEmpty()) {
      job = getVers(1).catch(function () { return null; }).then(function (v) {
        if (v && sameVers(v, meta.v)) { poolTs = fullTs = started; addToPool([]); return; }
        return full(v);
      });
    } else {
      job = full(null);
    }
    job.catch(setBackoff).then(function () { checking = false; });
  }
  /* Démarrage : 1 s après l'événement 'load' (pour ne pas concurrencer le chargement de la page),
     ou au plus tard 8 s après l'exécution du script si 'load' tarde (réseaux lents). Sinon : au 1er focus de la recherche. */
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      if (window.requestIdleCallback) window.requestIdleCallback(refreshIndex, { timeout: 4000 });
      else refreshIndex();
    }, 1000);
  }
  window.addEventListener('load', schedule);
  setTimeout(schedule, 7000);

  function thumb(u) {
    return u.indexOf('width=') > -1 ? u : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=120';
  }

  function initSearch(inputId, sugId) {
    var input = document.getElementById(inputId);
    var sug   = document.getElementById(sugId);

    /* Si les éléments ne sont pas encore dans le DOM, on réessaie */
    if (!input || !sug) {
      setTimeout(function() { initSearch(inputId, sugId); }, 150);
      return;
    }

    /* Éviter double écoute sur le même input */
    if (input.dataset.kmSearchReady) return;
    input.dataset.kmSearchReady = '1';

    var timer = null, lastHandled = '', activeIdx = -1, ctrl = null, lastHtml = '';

    function close() {
      sug.classList.remove('is-open');
      sug.innerHTML = '';
      lastHtml = '';
      input.setAttribute('aria-expanded', 'false');
      activeIdx = -1;
    }

    function render(all, q, noPrice, final) {
      /* Menu = produits DISPONIBLES seulement (décision Stefan 28/10) ; les ruptures restent visibles sur la page de résultats ("Voir tous les résultats"), en bas */
      var products = all.filter(function (p) { return p.a; }), nOut = outCount(q), html = '';
      if (!products.length && all.length) html += '<div class="km-search-sug-empty" style="padding:14px;font-size:13px;color:#666;">Ce produit est actuellement indisponible.</div>';

      if (products.length) {
        html += '<div class="km-search-sug-section"><div class="km-search-sug-label">Produits</div>';
        products.slice(0, MAX).forEach(function (p, n) {
          var price = (p.p && !noPrice) ? fmt(p.p) : '';
          var cmp = (p.c && !noPrice) ? fmt(p.c) : '';
          html += '<a class="km-search-sug-item" href="' + esc(p.u) + '">';
          if (p.i) html += '<img class="km-search-sug-img" src="' + esc(thumb(p.i)) + '" alt=""' + (n < 6 ? '' : ' loading="lazy"') + '>';
          else     html += '<div class="km-search-sug-img-placeholder"></div>';
          html += '<div class="km-search-sug-info">';
          html += '<div class="km-search-sug-title" style="white-space:normal;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;line-height:1.4;">' + hl(p.t, q) + '</div>';
          if (price) {
            html += '<div class="km-search-sug-price">' + price;
            if (cmp) html += '<s class="km-search-sug-compare" style="color:#9aa0a6;font-size:0.9em;font-weight:500;margin-left:8px;">' + cmp + '</s>';
            html += '</div>';
          }
          html += '</div></a>';
        });
        html += '</div>';
      }

      if (html) {
        html += '<div class="km-search-sug-footer">Voir tous les résultats — <a href="' + ROOT + 'search?q=' + encodeURIComponent(q) + '"><strong>« ' + esc(q) + ' »</strong></a>' + (nOut ? ' <span style="color:#9aa0a6;">(dont ' + nOut + ' indisponible' + (nOut > 1 ? 's' : '') + ')</span>' : '') + '</div>';
        if (html !== lastHtml) {
          sug.innerHTML = html;
          lastHtml = html;
          activeIdx = -1;
        }
        sug.classList.add('is-open');
        input.setAttribute('aria-expanded', 'true');
      } else if (final && !all.length) {
        /* v5.9 : réponse définitive sans aucun produit (ex. marque absente du catalogue) : on le dit au lieu de laisser le menu vide */
        sug.innerHTML = '<div class="km-search-sug-empty" style="padding:14px;font-size:13px;color:#666;">Aucun produit trouvé pour « ' + esc(q) + ' ». <a href="' + ROOT + 'search?q=' + encodeURIComponent(q) + '" style="color:#008560;text-decoration:underline;">Voir tous les résultats</a></div>';
        lastHtml = '';
        sug.classList.add('is-open');
        input.setAttribute('aria-expanded', 'true');
      } else {
        close();
      }
    }

    function fetchQ(q) {
      var nq = norm(q);
      if (ctrl) { try { ctrl.abort(); } catch (e) {} }
      ctrl = window.AbortController ? new AbortController() : null;
      fetch(sugUrl(q), ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          if (!data) return;
          var net = extract(data.resources).map(compact), base = net;
          /* v5.9 : catalogue déjà chargé => on ne garde du réseau que les produits qui correspondent à la saisie (ou à une faute de frappe d'une lettre) ; « oppo » ne montre plus des produits sans rapport */
          if (poolCount() > 500) net = net.filter(function (it) { return relevant(it, q); });
          base = net;
          addToPool(net);
          /* ÉTAPE 3 : pool récent => on y ajoute les produits locaux ; pool ancien => réponse réseau seule (prix sûrs) ; puis classement */
          if (poolTs && Date.now() - poolTs < PRICE_OK) {
            var seen = Object.create(null);
            base = [];
            net.concat(localMatch(q)).forEach(function (it) { var k = ukey(it.u); if (!seen[k]) { seen[k] = 1; base.push(it); } });
          }
          var list = rank(base, q);
          cacheQ[nq] = list;
          if (input.value.trim() === q) render(list, q, false, true);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          console.warn('[KM Search] Erreur:', err);
        });
    }

    /* Point d'entrée unique de la saisie (input, keyup, composition) : ne fait rien si le texte n'a pas changé */
    function onType() {
      var q = input.value.trim();
      if (q === lastHandled) return;
      lastHandled = q;
      clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      var nq = norm(q);
      if (cacheQ[nq]) { render(cacheQ[nq], q, false, true); return; }
      var loc = localMatch(q);
      if (loc.length) render(loc, q, !(poolTs && Date.now() - poolTs < PRICE_OK));  /* affichage immédiat, sans réseau (prix masqués si pool trop ancien) */
      timer = setTimeout(function () { fetchQ(q); }, loc.length ? 90 : 30);
    }

    input.addEventListener('input', onType);

    input.addEventListener('keydown', function (e) {
      var items = sug.querySelectorAll('.km-search-sug-item');
      if (!items.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); activeIdx = Math.min(activeIdx + 1, items.length - 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); activeIdx = Math.max(activeIdx - 1, -1); }
      else if (e.key === 'Escape') { close(); input.blur(); return; }
      else return;
      items.forEach(function (el, i) { el.classList.toggle('active', i === activeIdx); });
    });

    input.addEventListener('focus', function () {
      refreshIndex();
      lastHandled = '';
      onType();
    });

    /* Sur mobile : événement 'input' peut ne pas se déclencher sur certains claviers virtuels
       On ajoute 'compositionend' et 'keyup' comme fallback (dédupliqués par onType) */
    input.addEventListener('keyup', onType);
    input.addEventListener('compositionend', onType);

    document.addEventListener('click', function (e) {
      if (!input.contains(e.target) && !sug.contains(e.target)) close();
    });

    document.addEventListener('touchstart', function (e) {
      if (!input.contains(e.target) && !sug.contains(e.target)) close();
    }, { passive: true });
  }

  function boot() {
    if (poolEmpty()) refreshIndex(); /* 1re visite : on démarre tout de suite, sans attendre la fin du chargement */
    initSearch('km-search-input', 'km-search-sug');   /* Desktop */
    initSearch('km-msb-input', 'km-msb-suggestions'); /* Mobile  */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();

/* ===== KM — Bandeau noir (topheader) : couleur + espacement des liens (n'affecte pas la barre verte km-topbar) ===== */
(function () {
  if (window.__kmTopheaderStyle) return;
  window.__kmTopheaderStyle = true;
  var css =
    '.topheader a{color:#fff !important;text-decoration:none;font-weight:700;white-space:nowrap;display:inline-flex;align-items:center;margin:0 7px;}'
  + '.topheader a:hover{opacity:.85;}'
  + '.topheader a[href*="wa.me"]::before,.topheader a[href^="tel:"]::before{content:"";display:inline-block;width:15px;height:15px;margin-right:4px;background-size:contain;background-repeat:no-repeat;background-position:center;}'
  + '.topheader a[href*="wa.me"]::before{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE2IDNDOC44IDMgMyA4LjggMyAxNmMwIDIuNS43IDQuOSAxLjkgNi45TDMgMjlsNi4zLTEuOEMxMS4yIDI4LjMgMTMuNSAyOSAxNiAyOWM3LjIgMCAxMy01LjggMTMtMTNTMjMuMiAzIDE2IDN6bTAgMjMuNmMtMi4zIDAtNC40LS43LTYuMi0xLjlsLS40LS4zLTMuNyAxIDEtMy42LS4zLS40QzUuOSAxOS45IDUuMiAxOCA1LjIgMTYgNS4yIDEwIDEwIDUuMiAxNiA1LjJTMjYuOCAxMCAyNi44IDE2IDIyIDI2LjYgMTYgMjYuNnptNi04LjFjLS4zLS4yLTEuOS0xLTIuMi0xLjEtLjMtLjEtLjUtLjItLjguMi0uMi4zLS44IDEuMS0xIDEuMy0uMi4yLS40LjItLjcuMS0uMy0uMi0xLjQtLjUtMi42LTEuNi0xLS45LTEuNi0yLTEuOC0yLjMtLjItLjMgMC0uNS4xLS43LjEtLjEuMy0uNC41LS42LjEtLjIuMi0uMy4zLS42LjEtLjIgMC0uNCAwLS42LS4xLS4yLS44LTEuOS0xLjEtMi42LS4zLS43LS42LS42LS44LS42aC0uN2MtLjIgMC0uNi4xLS45LjQtLjMuMy0xLjIgMS4xLTEuMiAyLjhzMS4yIDMuMiAxLjQgMy41Yy4yLjIgMi40IDMuNyA1LjkgNS4yLjguNCAxLjUuNiAyIC43LjguMyAxLjYuMiAyLjIuMS43LS4xIDItLjggMi4zLTEuNi4zLS44LjMtMS40LjItMS42LS4xLS4xLS4zLS4yLS42LS40eiIvPjwvc3ZnPg==);}'
  + '.topheader a[href^="tel:"]::before{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iI2ZmZiI+PHBhdGggZD0iTTYuNiAxMC44YzEuNCAyLjggMy44IDUuMSA2LjYgNi42bDIuMi0yLjJjLjMtLjMuNy0uNCAxLS4yIDEuMS40IDIuMy42IDMuNi42LjYgMCAxIC40IDEgMVYyMGMwIC42LS40IDEtMSAxQzEwLjYgMjEgMyAxMy40IDMgNGMwLS42LjQtMSAxLTFoMy41Yy42IDAgMSAuNCAxIDEgMCAxLjIuMiAyLjQuNiAzLjYuMS40IDAgLjctLjIgMWwtMi4zIDIuMnoiLz48L3N2Zz4=);}'
  + '@media (min-width:769px){.topheader{display:none !important;}}'
  + '@media (max-width:768px){.topheader{display:flex !important;align-items:center !important;justify-content:center !important;min-height:30px !important;}.topheader > div{width:100%;}.topheader p{margin:0 !important;line-height:1 !important;display:flex !important;align-items:center !important;justify-content:center !important;flex-wrap:wrap;}}';
  var s = document.createElement('style');
  s.setAttribute('data-km', 'topheader-contacts');
  s.appendChild(document.createTextNode(css));
  (document.head || document.documentElement).appendChild(s);
})();
